import { useEffect, useState } from 'react';
//import { Link } from 'react-router-dom';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector as userSelector } from 'react-redux';

import { signin } from '../../redux/actions/userAction';
import LoadingBox from '../../Component/LoadingBox';
import MessageBox from '../../Component/MessageBox';
import Button from '../../Component/Button/index';

import './signinScreen.less';

export default function SigninScreen() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const userSignin = userSelector(state => state.userSignin);
  const { userInfo, loading, error } = userSignin;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  // const redirect = location.search
  //   ? Number(location.search.split('=')[1])
  //   : '/';

  const redirect =
    new URLSearchParams(window.location.search).get('redirect') || '/';

  const submitHandler = (e) => {
    e.preventDefault();
    // TODO: sign in action
    dispatch(signin(email, password));
  };

  useEffect(() => {
    //console.log('realize esta tare userInfo: ', userInfo);
    //() => {
    if (userInfo) {
      //console.log('realize esta tare redirect: ', redirect);
      navigate(redirect);
    }
    // };
  }, [userInfo, navigate, redirect]);

  return (
    <div>
      <form className="signin-form" onSubmit={submitHandler}>
        <div>
          <h1>Sign In</h1>
        </div>
        {loading && <LoadingBox></LoadingBox>}
        {error && <MessageBox variant="danger">{error}</MessageBox>}
        <div>
          <label htmlFor="email">Email address</label>
          <input
            type="email"
            id="email"
            placeholder="Enter email"
            required
            onChange={e => setEmail(e.target.value)}
          />
        </div>

        <div>
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            placeholder="Enter password"
            required
            onChange={e => setPassword(e.target.value)}
          ></input>
        </div>
        <div>
          <Button type="submit"> Sign In</Button>
          {/* <Button variant=" btn " type="submit">
            Sign In
          </Button> */}
        </div>
        <div>
          <div>
            New customer ?{' '}
            <Link to={`/register?redirect=${redirect}`}>
              Create your account
            </Link>
          </div>
        </div>
      </form>
    </div>
  );
}
